<template>
  <div class="h-100 w-100" style="height: 100vh!important;">
    <mdb-container fluid class="video-player h-100 no-padding">
      <mdb-row class="no-gutters flex-row-reverse">
        <mdb-col
          cols="12"
          md="9"
          class="video"
          v-sticky
          id="contentFrame"
          :class="backGroundColor()"
        >
          <iframe
            v-for="(item,index) in courseFirebaseData.newOrEditedCourseDetails"
            v-if="mthIsVimeoidDefined(item)"
            :src="mthGetVideoToPlay(item.data.data.vimeoid)"
            :key="dataIframeKey+'ifr'+index"
            :ref="'iframe'+index"
            :class="mthGetClassByIndexItem(index,item)"
            :vimeoid="item.data.data.vimeoid"
            width="100%"
            height="100%"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
            class="vimeo-iframe"
          ></iframe>

          <div
            class="flex-center"
            v-for="(item,index) in courseFirebaseData.newOrEditedCourseDetails"
            v-if="mthIsTextDefined(item)"
            :key="dataIframeKey+'ifr'+index"
            :class="mthGetClassByIndexItemIfText(index)"
          >
            <mdb-col md="9" class>
              <h3 class="text-uppercase">{{ item.title }}</h3>
              <div v-html="item.data" class="line-under"></div>
              <div @click="mthChangeLessonByIndex(1)" class="link float-right">
                Next lesson
                <mdb-icon icon="angle-double-right" />
              </div>
            </mdb-col>
          </div>

          <div
            @click="mthChangeLessonByIndex(1)"
            color="primary"
            class="button-next"
            :class="mthNextVideoButtonVisible"
            v-if="nextLessonLink"
          >
            <div>
              <span class="strong">Next:</span>
              {{ mthGetNextLessonTitle() }}
            </div>
            <div class="arrow">
              <mdb-icon icon="arrow-alt-circle-right" />
            </div>
          </div>

          <!--<div
            color="primary"
            class="button-next"
            rounded
          >
            <span>{{ mthGetNextVideoTitle() }}</span>
          </div>-->
        </mdb-col>
        <mdb-col cols="12" md="3" class="overflow-auto sm-100-vh" id="list-col">
          <h1>{{coursename}}</h1>
          <div class="go-back">
            <!--<a @click="mthBackButton">Go back</a>-->
            <a @click="mthBackButton()" class="back link">
              <mdb-icon icon="angle-double-left" />&nbsp;Back
            </a>
            <!-- Default checked -->
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="customSwitch1"
                v-model="autoPlay"
              />
              <label class="custom-control-label" for="customSwitch1">Autoplay</label>
            </div>
          </div>
          <div class="list">
            <template v-for="(item,index) in courseFirebaseData.newOrEditedCourseDetails">
              <!-- category -->
              <div v-if="item.type==='category'" class="list-element cat" :key="index">
                <h5>{{item.data}}</h5>
                <div class="ml-auto">
                  <span class>
                    <div @click="mthToggleCategory(item.data)">
                      <mdb-icon icon="angle-down" />
                    </div>
                  </span>
                </div>
              </div>
              <!-- subcategory -->
              <div
                v-if="item.type==='subcategory' && !collapsedCategoriesNames.includes(mthGetmyCategory2(index))"
                :key="item.data"
                class="list-element subcat"
              >
                <h5>{{item.data}}</h5>
                <div class="ml-auto">
                  <span class>
                    <div @click="mthToggleSubCategory(item.data)">
                      <mdb-icon icon="angle-down" />
                    </div>
                  </span>
                </div>
              </div>

              <!-- video -->
              <template
                v-if="
                  item.type==='video'
                  && !collapsedSubCategoriesNames.includes(mthGetmySubCategory(item.data.data.name))
                  && !collapsedCategoriesNames.includes(mthGetmyCategory2(index))
                "
              >
                <div
                  class="list-element lesson"
                  :key="item.data.data.vimeoid+'a'+index"
                  :title="item.data.data.vimeoid"
                  :class="mthListItemIsActive(item.data.data.vimeoid)"
                  :ref="'ref'+index"
                >
                  <mdb-icon icon="caret-right" />
                  <h5>
                    <a
                      @click="mthChangeCurrentVideo(item.data.data.vimeoid,index)"
                      :title="item.data.data.vimeoid + '(loop ' + index + ', chosen '+currentChosenIndex+')'"
                    >{{item.data.data.name}}</a>
                  </h5>
                  <div class="pull-right">
                    <mdb-icon
                      v-if="mthIsThisVideoWatched(item) && vimeoidsToMarkAsWatched.includes(item.data.data.vimeoid)"
                      icon="check"
                      class="check"
                    />
                    <span class="tixme">{{item.data.data.vimeoduration | timeInHours}}</span>
                  </div>
                </div>
              </template>

              <template
                v-if="
                item.type==='text'
                && !collapsedSubCategoriesNames.includes(mthGetmySubCategory(item.data))
                && !collapsedCategoriesNames.includes(mthGetmyCategory2(index))
                "
              >
                <div
                  class="list-element lesson"
                  :key="index+'b'"
                  :class="mthListItemTextIsActive(index)"
                  :ref="'ref'+index"
                >
                  <mdb-icon icon="caret-right" />
                  <h5>
                    <a @click="mthChangeCurrentText(index)" :title="item.title">{{item.title}}</a>
                  </h5>
                  <div class="ml-auto">
                    <!-- <mdb-icon icon="check" class="check" /> -->
                    <!--<span class="time">PDF</span>-->
                  </div>
                </div>
              </template>
            </template>
          </div>
        </mdb-col>
      </mdb-row>
      <!--
      <mdb-row class="no-gutters h-100">
        <mdb-col cols="12" md="3" class="course-view-right-col"></mdb-col>
        <mdb-col cols="12" md="9">
          <mdb-btn
            @click="mthChangeVideoByIndex(-1)"
            color="primary"
            class="float-left"
            rounded
          >Previous</mdb-btn>
          <mdb-btn
            @click="mthChangeVideoByIndex(1)"
            color="primary"
            class="float-right"
            rounded
          >Next</mdb-btn>
        </mdb-col>
      </mdb-row>
      -->
    </mdb-container>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
  mdbTbl,
  mdbIcon,
  mdbBtn,
  mdbListGroup,
  mdbListGroupItem,
  Sticky
} from "mdbvue";
import Vue from "vue";
import firebase from "firebase/app";
import { courseCatsSubcatsItemsMixin } from "../mixins/CourseCatsSubcatsItemsMixin";
import Player from "@vimeo/player";
import { store } from "../store";

export default {
  name: "VideoPlayer",
  directives: {
    sticky: Sticky
  },
  mixins: [courseCatsSubcatsItemsMixin],
  data() {
    return {
      //vimeosprogresses: [],
      email: "",
      revision: 20,
      players: [],
      coursename: "",
      dataIframeKey: 0,
      courseslug: "",
      vimeoidtoplay: "",
      currentChosenIndex: 0,
      currentProgress: 0,
      secondsFromProgressTracking: 0,
      courseFirebaseData: {},
      yourScore: 0,
      collapsedCategoriesNames: [],
      collapsedSubCategoriesNames: [],
      nextLessonLink: false,
      autoPlay: true
    };
  },
  created() {
    //console.log("Video Player Created Fired");

    //constants
    this.courseslug = this.$router.currentRoute.params.courseslug;
    this.email = this.$store.getters.getUser.email;
    //console.log("user: ", this.email);

    this.coursename = this.mthSlugToLabel(this.courseslug);
    this.coursefirebasedata = this.mthGetCourseFirebaseDataBySlug(
      this.courseslug
    );

    // if video
    if (this.$router.currentRoute.params.videoid.length > 3) {
      //console.log("LONGER ---------------------");
      let vimeoIdAndIndex = this.$router.currentRoute.params.videoid.split(",");
      this.vimeoidtoplay = vimeoIdAndIndex[0];
      this.currentChosenIndex = parseInt(vimeoIdAndIndex[1], 10);
      this.mthPlayVideo(vimeoIdAndIndex[0]);
    }

    // if NOT video
    if (this.$router.currentRoute.params.videoid.length < 3) {
      this.currentChosenIndex = parseInt(
        this.$router.currentRoute.params.videoid,
        10
      );
    }
  },
  mounted() {
    this.initPlayers();
    //console.log("%cmounted fired", "color:orange");
  },
  updated: function() {
    this.$nextTick(function() {
      //console.log("%cupdated fired", "color:orange");
    });

    //console.log(this.currentChosenIndex);
    //console.log(this.courseFirebaseData.newOrEditedCourseDetails[this.currentChosenIndex + 1]);
    //console.log(this.currentChosenIndex);
    //console.log(this.courseFirebaseData.newOrEditedCourseDetails[this.currentChosenIndex + 1].type);
    //console.log(this.courseFirebaseData.newOrEditedCourseDetails[this.currentChosenIndex].type);
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
    mdbTbl,
    mdbIcon,
    mdbBtn,
    mdbListGroup,
    mdbListGroupItem
  },
  methods: {
    backGroundColor() {
      let contentFrame = window.document.querySelector("#contentFrame");
      if (this.currentChosenIndex) {
        return "bg-white";
      } else {
        return "bg-black";
      }
    },
    mthBackButton() {
      //return "/course/" + this.courseslug;
      this.$router.replace("/course/" + this.courseslug);
    },
    listScrollTo() {
      let column = window.document.querySelector("#list-col");
      let ref = "ref" + this.currentChosenIndex;
      //console.log(this.$refs);
      let topPos = this.$refs[ref][0].offsetTop;
      //console.log("position: ", topPos);

      column.scrollTo({ top: topPos, behavior: "smooth" });

      //console.log('scrooll 2: ', this.$refs[ref] );
      /*this.$nextTick(function(){
				that.$refs[ref].offsetTop = 0;
			});*/
    },
    mthChangeCurrentText(index) {
      /*console.log(
        "this is text to show: " + title
      );*/

      //pause all videos
      let vimeoIframe = window.document.querySelectorAll(".vimeo-iframe");
      var nodelist = vimeoIframe.length;

      for (let i = 0; i < nodelist; i++) {
        this.players[i].pause();
      }

      let otherIframe = window.document.querySelectorAll(".other-iframe");
      otherIframe.forEach(function(currentValue, currentIndex, listObj) {
        currentValue.contentWindow.postMessage(
          '{"event":"command","func":"' + "stopVideo" + '","args":""}',
          "*"
        );
      });

      this.nextLessonLink = false;

      //hide all iframes
      this.vimeoidtoplay = 0;
      this.currentChosenIndex = index;

      this.listScrollTo();

      this.mthRegisterIndexProgressByEmailSlug(
        index,
        this.courseslug,
        store.getters.getUser.email
      );

      //console.log("to jest index", index);
    },
    mthIsTextDefined(item) {
      //console.log( item );
      if (item.type === "text") return true;
    },
    mthChangeLessonByIndex(shiftval) {
      // hide next lesson link
      this.nextLessonLink = false;

      //----

      let next = this.currentChosenIndex;
      next += 1;

      let data = this.courseFirebaseData.newOrEditedCourseDetails;
      //console.log("woow data next: ", data[next]);

      if (typeof data[next] === "undefined") {
        return;
      }

      if (data[next].type && data[next].type === "video") {
        this.currentChosenIndex = next;

        this.mthChangeCurrentVideo(
          data[next].data.data.vimeoid,
          this.currentChosenIndex
        );

        return;
      }

      if (data[next].type && data[next].type === "text") {
        this.currentChosenIndex = next;

        this.mthChangeCurrentText(next);

        return;
      }

      next += 1;

      if (data[next].type && data[next].type === "video") {
        this.currentChosenIndex = next;

        this.mthChangeCurrentVideo(
          data[next].data.data.vimeoid,
          this.currentChosenIndex
        );

        return;
      }

      if (data[next].type && data[next].type === "text") {
        this.currentChosenIndex = next;

        this.mthChangeCurrentText(next);

        return;
      }

      //----
      /*
      console.log(this.currentChosenIndex);
      this.currentChosenIndex += shiftval;
      if (
        this.courseFirebaseData.newOrEditedCourseDetails[
          this.currentChosenIndex
        ].type !== "video"
      )
        this.currentChosenIndex += shiftval;

      //console.log(this.currentChosenIndex);

      if (this.currentChosenIndex < 0) this.currentChosenIndex = 0;
      if (
        this.currentChosenIndex >
        this.courseFirebaseData.newOrEditedCourseDetails.length - 1
      )
        this.currentChosenIndex =
          this.courseFirebaseData.newOrEditedCourseDetails.length - 1;

      let vimeoidfromindex = this.courseFirebaseData.newOrEditedCourseDetails[
        this.currentChosenIndex
      ].data.data.vimeoid;

      this.mthChangeCurrentVideo(vimeoidfromindex, this.currentChosenIndex);

      */
    },
    mthGetNextLessonTitle() {
      //console.log(this.currentChosenIndex);

      let next = this.currentChosenIndex;
      /*       console.log(
        "current choosen:::::::::::::::::::: ",
        this.currentChosenIndex
      ); */
      next += 1;

      let data = this.courseFirebaseData.newOrEditedCourseDetails;

      //console.log("next::::::", next);
      //console.log("data next: ", data[next]);

      if (typeof data[next] === "undefined") {
        this.nextLessonLink = false;
        return;
        //console.log("undefined:::::::");
      }

      if (data[next].type && data[next].type === "video")
        return data[next].data.data.name;
      if (data[next].type && data[next].type === "text")
        return data[next].title;

      next += 1;

      if (data[next] === "undefined") return "end";

      if (data[next].type && data[next].type === "video")
        return data[next].data.data.name;
      if (data[next].type && data[next].type === "text")
        return data[next].title;

      /*
      let index = "";
      //if not last item
      if (
        this.courseFirebaseData &&
        this.courseFirebaseData.newOrEditedCourseDetails &&
        this.currentChosenIndex !==
          this.courseFirebaseData.newOrEditedCourseDetails.length - 1
      ) {
        index = this.currentChosenIndex + 1;

        if (
          this.courseFirebaseData.newOrEditedCourseDetails[index].type ===
          "video"
        )
          return this.courseFirebaseData.newOrEditedCourseDetails[index].data
            .data.name;
        // jeśli następny jest cat
        else index += 1;
        return this.courseFirebaseData.newOrEditedCourseDetails[index].data.data
          .name;
      }*/
    },
    mthGetClassByIndexItem(bigiindex, item) {
      //console.log('setting class for big index='+bigiindex)

      if (item.data.data.vimeoid == this.vimeoidtoplay) {
        /*console.log(
          "mthGetClassByIndexItem: visible video is: " + item.data.data.vimeoid
        );*/

        return "videovisible";
      }

      return "videohidden";
    },
    mthGetClassByIndexItemIfText(index) {
      //console.log('setting class for big index='+bigiindex)

      if (index == this.currentChosenIndex) {
        return "videovisible";
      }

      return "videohidden";
    },
    mthIsVimeoidDefined(item) {
      if (item === undefined) return false;
      if (item.data === undefined) return false;
      if (item.data.data === undefined) return false;
      if (item.data.data.vimeoid === undefined) return false;

      return true;
    },
    mthChangeCurrentVideo(vimeoid, index) {
      /*console.log(
        "%cmthChangeCurrentVideo: will pause all then play index " + index,
        "color:green"
      );*/
      this.currentChosenIndex = index;

      this.vimeoidtoplay = vimeoid;
      this.currentChosenIndex = index;

      //this.mthPauseAllThePlayers();

      this.mthPlayVideo(this.vimeoidtoplay);
      this.listScrollTo();

      this.mthRegisterIndexProgressByEmailSlug(
        index,
        this.courseslug,
        store.getters.getUser.email
      );

      /*
      console.log(this.mthPauseAllThePlayers());

      this.mthPauseAllThePlayers().then(() => {
        this.players[this.currentChosenIndex].play()
      });


      //this.players[this.currentChosenIndex].onCanPlay().play();


      let playPromise = this.players[this.currentChosenIndex].play();

      if (playPromise !== undefined) {
        playPromise.then(_ => {
          console.log('udało się z video');
          // Automatic playback started!
          // Show playing UI.
        })
        .catch(error => {
          console.log('NIE udało się z video');
          // Auto-play was prevented
          // Show paused UI.
        });
      }

      */

      //this.mthPlayVideo();
      //this.players[this.currentChosenIndex].play();
      //console.log("hello");
      //console.log(this.players[this.currentChosenIndex]);
    },
    mthPauseAllThePlayers() {
      this.players.forEach(el => {
        //console.log("%cpausing player ", "color:orange");
        //console.log(el);

        el.pause();
      });
      //this.players[this.currentChosenIndex].play();
    },
    mthPlayVideo(vimeoidtoplay) {
      //console.log('%cmthPlayVideo(): will play index '+this.currentChosenIndex,'color: pink;')

      //this.players[this.currentChosenIndex].play();
      let vimeoIframe = window.document.querySelectorAll(".vimeo-iframe");
      var nodelist = vimeoIframe.length;

      for (let i = 0; i < nodelist; i++) {
        let that = this;

        /*console.log(
          "---will play " +
            vimeoidtoplay +
            ", iframe[i] has vimeoid: " +
            iframe[i].attributes["vimeoid"].value
        );*/
        if (vimeoIframe[i].attributes["vimeoid"].value === vimeoidtoplay) {
          //console.log("---playing index " + i);
          this.players[i].play();
          //console.log("vimeo players: ", this.players[i]);
        } else {
          //console.log("---pausing index " + i);

          this.players[i].pause();
        }
      }

      let otherIframe = window.document.querySelectorAll(".other-iframe");

      otherIframe.forEach(function(currentValue, currentIndex, listObj) {
        currentValue.contentWindow.postMessage(
          '{"event":"command","func":"' + "stopVideo" + '","args":""}',
          "*"
        );
      });

      /*
      let otherIframe = window.document.querySelectorAll(".other-iframe");
      console.log("other iframe: ", otherIframe);
      //console.log("this other iframe: ", this.otherIframe[0].postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*'));
      //otherIframe[0].postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      otherIframe[0].stopVideo();
      */

      //
    },
    initPlayers() {
      firebase
        .firestore()
        .collection("progressTracking")
        .doc(store.getters.getUser.email + "-" + this.vimeoidtoplay)
        .get()
        .then(doc => {
          if (this.players.length == 0) {
            /*console.log(
              "players empty, will init: calling this.mthplayersinit()"
            );*/

            this.mthplayersinit();
          }
        });
    },
    mthplayersinit() {
      let that = this;

      let iframe = window.document.querySelectorAll(".vimeo-iframe");

      var nodelist = iframe.length;
      this.players = [];

      for (let i = 0; i < nodelist; i++) {
        let that = this;

        //console.log("creating player for smallindex " + i + ", iframe[i] is: ");
        //console.log(iframe[i].attributes["vimeoid"]);

        this.players[i] = new Player(iframe[i], {
          width: 640
        });

        //console.log('%cinitialized  ','color:green')
        if (iframe[i].attributes["vimeoid"].value === that.vimeoidtoplay) {
          //console.log("%ctrying to play ", "color:green");

          this.players[i].play();
        }

        this.players[i].on("ended", function() {
          //console.log("ended!!!" + that.vimeoidtoplay);
          that.mthRegisterEnded();
        });

        this.players[i].on("timeupdate", function(e) {
          let decimal = e.seconds - Math.floor(e.seconds);
          if (decimal < 0.4) that.mthRegisterProgress(e);
          //console.log("timeupdate " + decimal);
        });

        this.players[i].on("timeupdate", function(e) {
          let decimal = e.seconds - Math.floor(e.seconds);
          if (decimal < 0.4) that.mthRegisterProgress(e);
          //console.log("timeupdate " + decimal);

          if (decimal > 0.9) {
            let element = window.getElementsByClassName("");
          }
        });

        //set progress
        //console.log('A')

        firebase
          .firestore()
          .collection("progressTracking")
          .doc(
            store.getters.getUser.email +
              "-" +
              iframe[i].attributes["vimeoid"].value
          )
          .get()
          .then(doc => {
            //console.log('B')
            //console.log(doc);

            //console.log('pushing vimeoid: '+iframe[i].attributes["vimeoid"].value+', seconds: '+doc.data().event.seconds)
            if (doc && doc.exists && doc.data() && doc.data().event) {
              this.players[i].setCurrentTime(doc.data().event.seconds);
            } else {
              //console.log("no progress for ");
              //console.log(doc);
            }

            //that.vimeosprogresses.push({vimeoid: iframe[i].attributes["vimeoid"].value, docfromfirebase: doc.data().event.seconds})
          });

        //console.log("%cmthplayersinit(): ", "color:red;");

        //console.log(this.players);

        //this.players[i].setCurrentTime(this.secondsFromProgressTracking)
      }
    },
    mthIsThisVideoWatched(item) {
      let that = this;

      //console.log('trying to read index progress ',that.$store.getters.getUser.email + "_" + item.data.data.vimeoid);

      return false;

      if (item && item.data && item.data.data && item.data.data.vimeoid)
        firebase
          .firestore()
          .collection("progressTracking")
          .doc(that.$store.getters.getUser.email + "_" + item.data.data.vimeoid)
          .get()
          .then(doc => {
            if (!doc.exists) {
              /*               console.log(
                 "not exists for " + store.getters.getUser.email
               ); */
            } else {
              //console.log("exists");

              if (
                typeof that.vimeoidsToMarkAsWatched !== "undefined" &&
                doc &&
                doc.data() &&
                doc.data().vimeoidended &&
                that.vimeoidsToMarkAsWatched.length < 200 &&
                !that.vimeoidsToMarkAsWatched.includes(doc.data().vimeoidended)
              ) {
                //console.log("should be pushed", doc.data().vimeoidended);
                if (that.vimeoidsToMarkAsWatched.length < 200)
                  that.vimeoidsToMarkAsWatched.push(doc.data().vimeoidended);
              }
            }
          });

      return true;
    },
    mthRegisterEnded() {
      //console.log(this.$store.getters.getUser);

      let that = this;
      if (this.autoPlay) {
        //console.log("koniec");
        setTimeout(function() {
          that.mthChangeLessonByIndex(1);
        }, 3000);
      }

      firebase
        .firestore()
        .collection("progressTracking")
        .doc(this.$store.getters.getUser.email + "-" + this.vimeoidtoplay)
        .update({
          vimeoidended: this.vimeoidtoplay,
          userEmail: this.$store.getters.getUser.email,
          courseslug: this.courseslug
        });
    },
    mthRegisterProgress(e) {
      //console.log("je");
      //console.log(this.$store.getters.getUser);

      //REGISTRAR 1: each 5 secs registering video progress
      if (parseInt(e.seconds.toString()) % 5 == 0) {
        //console.log(e);
        //console.log(this.vimeoidtoplay);

        firebase
          .firestore()
          .collection("progressTracking")
          .doc(this.$store.getters.getUser.email + "-" + this.vimeoidtoplay)
          .set({
            event: e,
            userEmail: this.$store.getters.getUser.email,
            courseslug: this.courseslug,
            vimeoid: this.vimeoidtoplay,
            dateandtime: new Date(),
            videolistindexforstats: this.currentChosenIndex,
            howmuchvideosisinthiscourse: this.players.length
          });
      }

      if (parseInt(e.seconds.toString()) % 2 == 0) {
        // display nextLessonLink
        if (e.seconds < e.duration - 10) this.nextLessonLink = false;
        if (e.seconds > e.duration - 10) this.nextLessonLink = true;
      }

      //REGISTRAR 2: each 60 secs registering course progress
      // if (parseInt(e.seconds.toString()) % 5 == 0) {
      //   console.log(e);
      // }
    },
    mthGetVideoToPlay(vimeoid) {
      //if vimeoid given, will be used
      //otherwise this.vimeoidtoplay will be used
      if (vimeoid !== undefined)
        return "https://player.vimeo.com/video/" + vimeoid;

      return "https://player.vimeo.com/video/" + this.vimeoidtoplay;
    },
    mthListItemIsActive(vimeoId) {
      //console.log(vimeoId, this.vimeoidtoplay);
      if (
        typeof this.vimeoidtoplay !== "undefined" &&
        typeof vimeoId !== "undefined" &&
        vimeoId === this.vimeoidtoplay
      )
        return "active";
    },
    mthListItemTextIsActive(index) {
      /*       console.log(
        "hello it is me",
        index,
        this.currentChosenIndex,
        this.courseslug
      ); */

      if (index === this.currentChosenIndex) return "active";

      /*
      this.mthRegisterIndexProgressByEmailSlug(
        this.currentChosenIndex,
        this.courseslug,
        this.email
      );
      */

      //console.log("To my: ",  this.$store.getters.getUser.email);
      //return "";

      //console.log("To my: ", this.currentChosenIndex, this.courseslug, store.getter.getUser.email);
    },
    mthNextVideoButtonVisible() {
      if (
        this.currentChosenIndex !==
        this.courseFirebaseData.newOrEditedCourseDetails.length - 1
      )
        return "d-none";
      //console.log("ostatni");
    }
  }
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.videohidden {
  display: none;
}
.videovisible {
  display: flex;
}
</style>
